// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var ListTriggersRequest_SortOptions;
(function (ListTriggersRequest_SortOptions) {
    ListTriggersRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListTriggersRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListTriggersRequest_SortOptions["DELETED_AT"] = "DELETED_AT";
    ListTriggersRequest_SortOptions["TRIGGER_AT"] = "TRIGGER_AT";
})(ListTriggersRequest_SortOptions || (ListTriggersRequest_SortOptions = {}));
export var ListTriggersRequest_SortOptions_index;
(function (ListTriggersRequest_SortOptions_index) {
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["DELETED_AT"] = 2] = "DELETED_AT";
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["TRIGGER_AT"] = 3] = "TRIGGER_AT";
})(ListTriggersRequest_SortOptions_index || (ListTriggersRequest_SortOptions_index = {}));
export const MetlAmpService = {
    // TriggerFilterOptions returns valid filter options for a Location and the provided source_tenant_ids.
    TriggerFilterOptions(fn, req) {
        return fn(`/messaging/etl/amp/v1/triggers/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ActiveTriggerTypes returns a list of active trigger types for the provided location and source tenants.
    // A trigger is active when there are records synced for that trigger type.
    ActiveTriggerTypes(fn, req) {
        return fn(`/messaging/etl/amp/v1/triggers/active?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetLocations returns all active locations by org id.
    GetLocations(fn, req) {
        return fn(`/messaging/etl/amp/v1/locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
